export const SUCCESS_MESSAGE = () => 'Update successfully'

export const calculateTimeAgo = (date: string) => {
  const givenDate = new Date(date);
  const now = new Date();
  const differenceInSeconds = Math.floor((now.getTime() - givenDate.getTime()) / 1000);

  const minutes = Math.floor(differenceInSeconds / 60);
  const hours = Math.floor(differenceInSeconds / 3600);
  const days = Math.floor(differenceInSeconds / (3600 * 24));

  // Return formatted time difference based on the value
  if (minutes < 60) {
    return minutes > 0 ? `Updated ${minutes} min ago` : 'Just now';
  } else if (hours < 24) {
    return hours > 0 ? `Updated ${hours} hour${hours > 1 ? 's' : ''} ago` : 'Just now';
  } else if (days < 30) {
    return days > 0 ? `Updated ${days} day${days > 1 ? 's' : ''} ago` : 'Just now';
  } else {
    // If more than 30 days ago, return months or years
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (months < 12) {
      return `Updated ${months} month${months > 1 ? 's' : ''} ago`;
    } else {
      return `Updated ${years} year${years > 1 ? 's' : ''} ago`;
    }
  }
};